import { routePaths } from '@/models/RoutePath';
import CategoryPage from '@/components/pages/CategoryPage.vue';
import BoxDetailPage from '@/components/pages/BoxDetailPage.vue';
// 2. Define some routes
// Each route should map to a component. The "component" can
// either be an actual component constructor created via
// `Vue.extend()`, or just a component options object.
// We'll talk about nested routes later.

export const routes = [
	{
		name: 'Home',
		path: routePaths.home,
		component: () => import('@/components/pages/LandingPage'),
		// beforeEnter(){
		// 	window.location.href = "www.samsung-upcyclepackaging.com"
	    // },
	},
	{ path: `${routePaths.categories}/:category`, component: CategoryPage },
	{
		name: 'BoxDetail',
		path: `${routePaths.box}/:categoryKey/:boxKey`,
		component: BoxDetailPage,
		props: true,
	},
	{
		path: '/privacypolicy',
		component: () =>
			import('@/components/pages/privacypolicy/PrivacyPolicyPage'),
	},
	//this is temporal page for sustanability
	{
		path: '/sustainability',
		component: () =>
			import('@/components/pages/sustainabilityPage'),
		// beforeEnter(){
		// 	window.location.href = "www.samsung-upcyclepackaging.com/sustainability"
		// },
	},
	{
		name: 'goinggreen',
		path: '/goingGreen',
		redirect:'/'
	},

	//For going Green
	// {
	// 	name: 'moreinfo',
	// 	path: '/moreinfo',
	// 	component: () => import('@/components/pages/MoreInfoPage'),
	// },
	// {
	// 	path: '/moreinfoSearch',
	// 	name: 'moreinfoSearch',
	// 	component: () => import('@/components/pages/MoreInfoSearchPage'),
	// },
	// {
	// 	name: 'camera',
	// 	path: '/camera',
	// 	component: () => import('@/components/pages/CameraPage'),
	// },
	// {
	// 	name: 'searchDetail',
	// 	path: '/searchDetail',
	// 	component: () => import('@/components/pages/SearchDetailPage'),
	// },
	// {
	// 	name: 'searchFail',
	// 	path: '/searchFail',
	// 	component: () => import('@/components/pages/SearchFailPage'),
	// },

	// {
	// 	name: 'goinggreen',
	// 	path: '/goingGreen',
	// 	redirect:'/'
	// },

	// Because of Going Green->Everyday Sustainability issue redirecting home
	// {
	// 	name: 'goinggreen',
	// 	path: '/goinggreen',
	// 	component: () => import('@/components/pages/GoingGreenPage'),
	// },
	// {
	// 	name: 'goinggreen',
	// 	path: '/goinggreen',
	// 	component: () => import('@/components/pages/LandingPage'),
	// },
	// {
	// 	name: 'search',
	// 	path: '/search',
	// 	component: () => import('@/components/pages/SearchPage'),
	// },
	// {
	// 	name: 'searchView',
	// 	path: '/searchView',
	// 	component: () => import('@/components/pages/SearchViewPage'),
	// },
	// {
	// 	name: 'searchPhoto',
	// 	path: '/searchPhoto',
	// 	component: () => import('@/components/pages/SearchPhotoPage'),
	// },
	// {
	// 	name: 'photoResult',
	// 	path: '/photoResult',
	// 	component: () => import('@/components/pages/PhotoResultPage'),
	// },
	////////////////////////////////
	{
		path: '*',
		redirect: '404',
	},
	{
		path: '/404',
		component: () => import('@/components/pages/PageNotFound.vue'),
	},
	// { path: "/categories/:id", component: Bar },
	// { path: "/products/:id", component: Bar },
];

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
